module.exports = __webpack_public_path__ + "media/正念冥想.e7e81a56.mp3";